/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IBusinessSignUpOptionProps {
    id: string;
    isRequired: boolean;
    options: IBusinessSignUpOptionOptionProps[];
}

export interface IBusinessSignUpOptionOptionProps {
    id: string;
    value: string;
    label: string;
}

export const BusinessSignUpOption: React.FC<IBusinessSignUpOptionOptionProps> = props => {
    const { id, value, label } = props;

    return (
        <option id={id} value={value}>{label}</option>
    );
};

export default BusinessSignUpOption;
